<template>
  <div data-testid="conversation">
    <v-tooltip bottom content-class="tooltip-bottom" data-testid="conversation__tooltip">
      <template v-slot:activator="{ on, attrs }">
        <base-button small :image-width="imageWidth" name="conversations" v-bind="attrs" v-on="on" icon-style @click.stop="onConversationClick" data-testid="conversation__open-btn">
          <v-badge class="conversation-badge" color="error" offset-x="10" offset-y="10" top dot :value="notify" data-testid="conversation__badge">
            <img :color="highlight?'blue':''" :image-width="imageWidth"  data-testid="conversation__icon-main" src="/img/icons/conversation.svg" alt="">
          </v-badge>
        </base-button>
      </template>
      <span data-testid="conversation__tooltip-title">Conversation</span>
    </v-tooltip>
    <v-dialog v-model="dialog" scrollable :max-width="width" data-testid="conversation__dialog">
      <v-card :loading="loading" :disabled="loading" loader-height="2" data-testid="conversation__card">
        <div class="popupHeader d-flex align-center py-2 px-4" data-testid="conversation__header">
          <span class="font-size-md" data-testid="conversation__title">{{ heading }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" class="ml-2 white--text" data-testid="conversation__close-btn">
            <v-icon data-testid="conversation__close-icon">mdi-close</v-icon></v-btn>
          </div>
        <v-divider data-testid="conversation__divider"></v-divider>
        <v-card-text class="mt-4" data-testid="conversation__body">
          <div ref="chatContainer" class="chat-container" data-testid="conversation__chat-container">
            <div v-for="(item, index) in conversationList" :key="index"  class="chat-message" data-testid="conversation__item">
              <div color="rgba(0,0,0,0)" flat class="mb-2 d-flex justify-end" v-if="item.user == $store.state.user.id" data-testid="conversation__item-row">
                <div class="text-right line-1" data-testid="conversation__item-message-row">
                  <v-card  dark class="ml-2 shadow-off d-inline-block rounded-lg pa-1 rounded-br-0 outlined"
                    max-width="500px" color="blue" data-testid="conversation__item-message-card">
                    <v-card-text class="py-0 px-3" data-testid="conversation__item-message-text">
                      <div class="white--text" :id="'sent-chat-message-'+index" data-testid="conversation__item-message" v-html="formatCommentMessage(item.value)"></div>
                    </v-card-text>
                  </v-card>

                  <div class="timeFont mt-1" data-testid="conversation__item-date">
                    {{
                      $nova.formatDateTime(item.created_at, "DD MMM yyyy hh:mm A")
                    }}
                  </div>
                </div>

                <v-tooltip bottom v-if="(conversationList[index-1] || {}).user !== item.user" data-testid="conversation__item-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar class="ml-2" size="30" elevation="10" v-bind="attrs" v-on="on" :color="
                      item.user_detail._id == $store.state.user.id
                        ? 'indigo'
                        : 'red'
                    " data-testid="conversation__item-avatar">
                      <v-img
                      v-if="item.user_detail.profile_url && showprofile"
                      alt="Avatar"
                      width="30px"
                      height="30"
                      :size="30"
                      :src="item.user_detail.profile_url"
                      data-testid="conversation__item-avatar-img"
                    ></v-img>
                    <span class="white--text" v-else-if="item.user_detail.name && item.user_detail.name !== ''" data-testid="conversation__item-avatar-initial">{{ item.user_detail.name[0] }}</span>
                    <span class="white--text" v-else data-testid="conversation__item-avatar-initial-email">{{ item.user_detail.email[0]?.toUpperCase() }}</span>
                    </v-avatar>
                  </template>
                  <span v-if="item.user_detail.name && item.user_detail.name !== ''" data-testid="conversation__item-avatar-name">{{ item.user_detail.name }}</span>
                  <span class="white--text" v-else data-testid="conversation__item-avatar-email">{{ item.user_detail.email }}</span>
                </v-tooltip>
                <span v-else class="mr-9" data-testid="conversation__item-avatar-gap"></span>
              </div>

              <div color="rgba(0,0,0,0)" flat class="d-flex mb-2" v-else data-testid="conversation__item-row-other">
                <v-tooltip bottom v-if="(conversationList[index-1] || {}).user !== item.user" data-testid="conversation__item-tooltip-other">
                  <template v-slot:activator="{ on, attrs }">
                    <v-avatar dark class="" size="30" elevation="10" v-bind="attrs" v-on="on"
                      :color=" item.user_detail._id == $store.state.user.id
                        ? 'indigo'
                        : 'indigo'
                    "
                    data-testid="conversation__item-avatar-other"
                    >
                      <v-img
                      v-if="item.user_detail.profile_url && showprofile"
                      alt="Avatar"
                      width="30px"
                      height="30"
                      :size="30"
                      :src="item.user_detail.profile_url"
                      data-testid="conversation__item-avatar-img-other"
                    ></v-img>
                    <span class="white--text" v-else-if="item.user_detail.name && item.user_detail.name !== ''" data-testid="conversation__item-avatar-initial-other">{{ item.user_detail.name[0] }}</span>
                    <span class="white--text" v-else data-testid="conversation__item-avatar-initial-email-other">{{ item.user_detail.email[0].toUpperCase() }}</span>
                    </v-avatar>
                  </template>
                  <span v-if="item.user_detail.name && item.user_detail.name !== ''" data-testid="conversation__item-avatar-name-other">{{ item.user_detail.name }}</span>
                  <span class="white--text" v-else data-testid="conversation__item-avatar-email-other">{{ item.user_detail.email }}</span>
                </v-tooltip>
                <div v-else class="ml-9" data-testid="conversation__item-avatar-gap-other"></div>

                <div data-testid="conversation__item-message-row-other">
                  <v-card  class="ml-2 shadow-off d-inline-block rounded-lg pa-1 rounded-bl-0 outlined" max-width="500px"
                    color="blue-grey lighten-5" data-testid="conversation__item-message-card-other">
                    <v-card-text class="py-0 px-3" data-testid="conversation__item-message-text-other">
                      <div class="self-message" :id="'receive-chat-message-'+index" data-testid="conversation__item-message-other" v-html="formatCommentMessage(item.value)"></div>
                    </v-card-text>
                  </v-card>
                  <div class="ml-4 mt-1 timeFont line-1" data-testid="conversation__item-date-other">
                    {{
                      $nova.formatDateTime(item.created_at, "DD MMM yyyy hh:mm A")
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="(conversationList || []).length === 0" class="font-size-lg text-center my-5 grey--text" data-testid="conversation__empty-state">
              No Conversation added yet
            </div>
          </div>
        </v-card-text>
        <v-card-actions v-if="!closed" data-testid="conversation__actions">
          <v-card-text class="px-0" data-testid="conversation__actions-body">
            <div class="d-flex align-center mb-1" v-if="recurring" data-testid="conversation__recurring-row">
              <v-checkbox label="Reucurring Comment" class="mr-2 pa-0 ma-0" dense hide-details
                v-model="recurringMsg" data-testid="conversation__recurring-checkbox"></v-checkbox>
              <v-tooltip right content-class="tooltip-right" data-testid="conversation__recurring-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="blue-grey lighten-2" dark v-bind="attrs" v-on="on" data-testid="conversation__recurring-icon">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span class="text-justify" data-testid="conversation__recurring-tooltip-text">{{ recurringtext }}</span>
              </v-tooltip>
            </div>
            <div class="d-flex align-center" data-testid="conversation__input-row">
              <lb-string label="Type your message here" hidedetails @enter="sendQuery()" v-model="queryMsg" :isRequired="true" data-testid="conversation__input"/>
              <v-btn color="primary" class="ml-3" :loading="loading" @click="sendQuery()" data-testid="conversation__send-btn">
                <v-icon class="mr-2" data-testid="conversation__send-icon">mdi-send</v-icon><span data-testid="conversation__send-label">Send</span></v-btn>
            </div>
          </v-card-text>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { formatCommentMessage } from '@/views/common/commentMessageFormat';

export default {
  name: "conversations",
  data() {
    return {
      dialog: false,
      loading: false,
      conversationList: [],
      queryMsg: "",
      recurringMsg: false,
    };
  },
  props: {
    getapi: {
      type: String,
      default: "",
    },
    sendapi: {
      type: String,
      default: "",
    },
    readapi: {
      type: String,
      default: "",
    },
    heading: {
      type: String,
      default: "Conversation",
    },
    recurring: {
      type: Boolean,
      default: false,
    },
    recurringtext: {
      type: String,
      default: "Requirements comments for next time",
    },
    notify: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "800",
    },
    type: {
      type: String,
      default: "string",
    },
    closed: {
      type: Boolean,
      default: true,
    },
    highlight: {
      type: Boolean,
      default: false
    },
    showprofile:{
      type:Boolean,
      default:true
    },
    /** @type {Object} Optional filter object to pass with API requests */
    filter: {
      type: Object,
      default: () => ({})
    },
    imageWidth: {
      type: [Number, String],
      default: 16,
    },
  },
  methods: {
    formatCommentMessage,
    onConversationClick() {
      this.conversationList = [];
      this.getProjectCon(true);
    },
    sendQuery() {
      if(this.queryMsg){
        this.loading = true;
        let dataObject = {
          type: this.type,
          value: this.queryMsg,
          status: this.status,
        };
        // console.log(dataObject);
        // Build request body with optional filter
        const requestBody = { data: dataObject };
        if (Object.keys(this.filter).length > 0) {
          requestBody.filter = this.filter;
        }
        let successflag = false;
        this.axios
          .post(this.sendapi, requestBody)
          .then((dt) => {
            if (dt.data.status === "success") {
              successflag = true;
              // this.$store.commit("sbSuccess", "successfully sended");
              this.queryMsg = "";
              
            }else throw Error(dt.data.message || "Unknown error")
          })
          .catch((err) => {
            this.$store.commit("sbError", err.message || err || "Unknown error!");
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
            if(successflag) this.getProjectCon();
          });
      }
    },
    getProjectCon(mark=false) {
      this.dialog = true;
      this.loading = true;
      this.$nova.apiGet.call(this, this.getapi, this.filter)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.conversationList = dt.data.data;
            if(mark) this.markAsRead();
          }else throw Error(dt.data.message || "Unknown error")
          // console.log(this.conversationList);
        })
        .catch((err) => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
          this.scrollToBottom();
        });
    },
    markAsRead() {
      // Build request body with optional filter
      const requestBody = Object.keys(this.filter).length > 0 ? { filter: this.filter } : {};
      this.axios
        .post(this.readapi, requestBody)
        .then((dt) => {
          if (dt.data.status === "success") {
            this.$emit("markread");
          }else throw Error(dt.data.message || "Unknown error")
          // console.log(this.conversationList);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
        });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatContainer = this.$refs.chatContainer;
        if (chatContainer) {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
      });
    }
  },
  mounted() {
    // Auto-scroll to the bottom when the component is mounted
    this.scrollToBottom();
  }
};
</script>

<style lang="scss" scoped>
.timeFont {
  font-size: 9px !important;
}

.chat-container {
  // height: 300px;
  min-height: 50px; /* Set minimum height */
  max-height: 400px;
  overflow-y: auto;
  border: 0px solid #ccc;
  padding: 2px;
}

.chat-message {
  margin-bottom: 10px;
}

@media screen and (min-width: 1024px) {
  .chat-container {
    max-height: 600px;
  }
}

/* Smaller screens (tablets) */
@media screen and (max-width: 1023px) {
  .chat-container {
    max-height: 300px;
  }
}

/* mobile screens */
@media screen and (max-width: 768px) {
  .chat-container {
    max-height: 200px;
  }
}
.conversation-badge{
  display: flex !important;
}
</style>

<style>
.tagged-name {
  color: var(--color-error);
  font-weight: bold;
}

.hash-tag {
  color: var(--color-pending-approval);
  font-weight: bold;
}
</style>

